// Auth
export const LOGIN_URL = "/auth/login";
export const FETCH_USER_INFO_URL = "/auth/user-info";
export const SIGN_UP_URL = "/auth/sign-up";
export const COMPANY_INFORMATION = "/users/info";
export const REFRESH_TOKEN = "/auth/refresh-token";
export const VERIFY_EMAIL = "/auth/verify/email";
export const RESEND_CODE = "/auth/resend-code/email";
export const REQUEST_PASSWORD_RESET = "/auth/reset-password";
export const VERIFY_PASSWORD_RESET_CODE = "/auth/reset-password/verify";
export const UPDATE_PASSWORD = "/auth/reset-password/password";

// Certificates
export const UPLOAD_CERTIFICATE = "/virtual-pos/upload-certificate";
export const FETCH_CERTIFICATES = (page, perPage, term, sortBy, order) =>
  `/fiscal-devices/certificates?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;
export const DELETE_CERTIFICATE = (id) => `/fiscal-devices/certificates/${id}`;

//taxpayers
export const FETCH_TAXPAYERS = (page, perPage, term) =>
  `/companies?page=${page}&perPage=${perPage}&term=${term}`;
export const FETCH_COMPANY_INFO = (id) => `/invoicing-system/companies/${id}/info`;

//fiscal device
export const FETCH_FISCAL_DEVICES = (
  page,
  perPage,
  term,
  sortBy,
  order,
  filterOffline = false,
  filterNoRecentInvoices = false,
  offset = 180,
  includeHealthFlags = false,
  includeTags = false,
  tagIds = null
) => {
  let url = `/fiscal-devices?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}&filterOffline=${filterOffline}&filterNoRecentInvoices=${filterNoRecentInvoices}&offset=${offset}&includeHealthFlags=${includeHealthFlags}&includeTags=${includeTags}`;
  if (tagIds && tagIds.length > 0) {
    url += `&tagIds=${tagIds.join(',')}`;
  }
  return url;
};
export const FETCH_SINGLE_FISCAL_DEVICE = (id) => `/fiscal-devices/${id}`;
export const UPDATE_FISCAL_DEVICE = "/fiscal-devices";
export const DOWNLOAD_XLS = "/fiscal-devices/download";
export const FETCH_FISCAL_DEVICE_INVOICES = (
  id,
  page,
  perPage,
  term,
  sortBy,
  order
) =>
  `/fiscal-devices/${id}/invoices?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;
export const SYNC_INVOICES = (fiscalDeviceId, from) =>
  `fiscal-devices/${fiscalDeviceId}/sync-missing-invoices?from=${from}`;
//user fiscal devices
export const FETCH_USER_FISCAL_DEVICES = (page, perPage, term, sortBy, order) =>
  `/user/fiscal-devices?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;
export const FETCH_SINGLE_USER_FISCAL_DEVICE = (id) =>
  `/user/fiscal-devices/${id}`;
export const FETCH_USER_FISCAL_DEVICE_INVOICES = (
  id,
  page,
  perPage,
  term,
  sortBy,
  order
) =>
  `/user/fiscal-devices/${id}/invoices?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;

export const EXPORT_FISCAL_DEVICE_INVOICES = (id, from, to) =>
  `/user/fiscal-devices/${id}/export-invoices?from=${from}&to=${to}`;

export const FETCH_FISCAL_DEVICE_DOUBLE_INVOICES = (fiscalDeviceId, offset) =>
  `/fiscal-devices/${fiscalDeviceId}/invoices/check?interval=${offset}`;
//vending controllers
export const FETCH_PENDING_VENDING_CONTROLLERS = (page, perPage, term) =>
  `/fiscal-devices/esp/pending?page=${page}&perPage=${perPage}&term=${term}`;
export const FETCH_ACTIVE_VENDING_CONTROLLERS = (
  page,
  perPage,
  term,
  filterOffline
) =>
  `/fiscal-devices/esp/active?page=${page}&perPage=${perPage}&term=${term}&filterOffline=${filterOffline}`;
export const ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE = (id) =>
  `/fiscal-devices/esp/${id}/fiscal-device`;
export const ADD_ITEM_TO_VENDING_CONTROLLER = (id) =>
  `/fiscal-devices/esp/${id}/items`;
export const GET_VENDING_CONTROLLER = (id) => `/fiscal-devices/esp/${id}`;
export const RELEASE_VENDING_CONTROLLER = (id) =>
  `/fiscal-devices/esp/${id}/release`;
export const DELETE_ITEM = (id, itemId) =>
  `/fiscal-devices/esp/${id}/items/${itemId}`;
export const UPDATE_ITEM = (id) => `/fiscal-devices/esp/${id}/items`;
export const GET_VENDING_CONTROLLER_LAST_INVOICE = (id, captchaData) =>
  `/fiscal-devices/esp/${id}/invoice?captcha=${captchaData}`;
export const GET_VENDING_CONTROLLER_INVOICES = (
  id,
  page,
  perPage,
  term,
  sortBy,
  order
) =>
  `/fiscal-devices/esp/${id}/invoices?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;
export const UPDATE_VENDING_CONTROLLER = "/fiscal-devices/esp";
export const BULK_REASSIGN_VENDING_CONTROLLERS =
  "/fiscal-devices/esp/bulk-reassign";
export const DOWNLOAD_VENDING_CONTROLLERS_XLS = "/fiscal-devices/vending-controllers/download";
export const FETCH_FISCAL_DEVICE_LOGS = (
  id,
  page,
  perPage,
  term,
  filterLogTypes,
  sortBy,
  order
) => {
  const filter = filterLogTypes && `[${filterLogTypes.join(",")}]`;
  const url = filter
    ? `/fiscal-device-logs/${id}?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}&filterLogTypes=${filter}`
    : `/fiscal-device-logs/${id}?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;
  return url;
};
//tax lables
export const GET_ALL_TAX_LABELS = "/tax";
export const ADD_TAX_LABEL = "/tax";

// API Keys
export const FETCH_API_KEYS = (page, perPage, term, sortBy, order) =>
  `/api-keys?page=${page}&perPage=${perPage}&term=${term}&sortBy=${sortBy}&order=${order}`;
export const CREATE_API_KEY = "/api-keys";
export const UPDATE_API_KEY = (id) => `/api-keys/${id}`;
export const DELETE_API_KEY = (id) => `/api-keys/${id}`;

//users
export const FETCH_ALL_USERS = (page, perPage, term) =>
  `/users?page=${page}&perPage=${perPage}&term=${term}`;
export const SINGLE_USER = (id) => `/users/${id}`;
export const UPDATE_SINGLE_USER = "/users";
export const DELETE_SINGLE_USER = "/users";

//report
export const FETCH_COMPANY_REPORT_ADMIN = (
  companyId,
  from,
  to,
  type,
  includeDays
) =>
  `/revenue/company/${companyId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_BUSINESS_UNIT_REPORT_ADMIN = (
  businessUnitId,
  from,
  to,
  type,
  includeDays
) =>
  `/revenue/business-unit/${businessUnitId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_FISCAL_DEVICE_REPORT_ADMIN = (
  fiscalDeviceId,
  from,
  to,
  type,
  includeDays
) =>
  `/revenue/fiscal-device/${fiscalDeviceId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_VENDING_CONTROLLER_REPORT_ADMIN = (
  vendingControllerId,
  from,
  to,
  type,
  includeDays
) =>
  `/revenue/vending-controller/${vendingControllerId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

//report
export const FETCH_COMPANY_REPORT_USER = (
  companyId,
  from,
  to,
  type,
  includeDays
) =>
  `/user/revenue/company/${companyId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_BUSINESS_UNIT_REPORT_USER = (
  businessUnitId,
  from,
  to,
  type,
  includeDays
) =>
  `/user/revenue/v2/business-unit/${businessUnitId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_FISCAL_DEVICE_REPORT_USER = (
  fiscalDeviceId,
  from,
  to,
  type,
  includeDays
) =>
  `/user/revenue/fiscal-device/${fiscalDeviceId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_VENDING_CONTROLLER_REPORT_USER = (
  vendingControllerId,
  from,
  to,
  type,
  includeDays
) =>
  `/user/revenue/vending-controller/${vendingControllerId}?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_ALL_BUSINESS_UNITS_REPORTS = (from, to, type, includeDays) =>
  `/user/revenue/business-units?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const FETCH_ALL_BUSINESS_UNITS_REPORTS_CACHED = (
  from,
  to,
  type,
  includeDays
) =>
  `/user/revenue/business-units/cache/v2?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const EXPORT_ALL_BUSINESS_UNITS_REPORTS_CACHED = (
  from,
  to,
  type,
  includeDays
) =>
  `/user/revenue/business-units/export-cache/v2?from=${from}&to=${to}&type=${type}&includeDays=${includeDays}`;

export const CREATE_FISCAL_DEVICE_UPDATE =
  "/fiscal-devices-updates/schedule-update";

//analytics
export const FETCH_DEVICE_ANALYTICS = (deviceId, deviceType, from, to) =>
  `/analytics/uptime-downtime?from=${from}&to=${to}&deviceType=${deviceType}&deviceId=${deviceId}`;
export const FETCH_BUSYNESS_REPORT = (fiscalDeviceId, from, to) =>
  `/analytics/busyness?from=${from}&to=${to}&fiscalDeviceId=${fiscalDeviceId}`;

// Intervend Sync Queue
export const INTERVEND_QUEUE_METRICS = "/intervend-sync/queue/metrics";
export const INTERVEND_QUEUE_SUMMARY = "/intervend-sync/queue/summary";
export const INTERVEND_QUEUE_JOBS = (state, page, perPage) =>
  `/intervend-sync/queue/jobs?state=${state}&page=${page}&perPage=${perPage}`;
export const INTERVEND_QUEUE_TRUNCATE = "/intervend-sync/queue/truncate";

// VSDC Failed Requests
export const VSDC_FAILED_REQUESTS = (limit) =>
  `/virtual-pos/vsdc/failed-requests${limit ? `?limit=${limit}` : ""}`;
export const VSDC_CLEAR_FAILED_REQUESTS = "/virtual-pos/vsdc/failed-requests";

// Virtual POS Test
export const VIRTUAL_POS_TEST_DEVICES = "/virtual-pos/test-devices";
export const VIRTUAL_POS_SUBMIT_INVOICE = "/virtual-pos/invoices";

// Billing Invoices
export const BILLING_INVOICES = (page, perPage, companyId, status, search, billingPeriodStart, billingPeriodEnd, isPaid) => {
  let url = `/invoicing-system/billing-invoices?page=${page}&perPage=${perPage}`;
  if (companyId) url += `&companyId=${companyId}`;
  // Handle multiple statuses - if status is an array or comma-separated string, add multiple status params
  if (status) {
    if (Array.isArray(status)) {
      status.forEach(s => {
        if (s) url += `&status=${encodeURIComponent(s)}`;
      });
    } else if (typeof status === 'string' && status.includes(',')) {
      // Comma-separated string - split and add multiple params
      status.split(',').forEach(s => {
        const trimmed = s.trim();
        if (trimmed) url += `&status=${encodeURIComponent(trimmed)}`;
      });
    } else {
      url += `&status=${encodeURIComponent(status)}`;
    }
  }
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (billingPeriodStart) url += `&billingPeriodStart=${encodeURIComponent(billingPeriodStart)}`;
  if (billingPeriodEnd) url += `&billingPeriodEnd=${encodeURIComponent(billingPeriodEnd)}`;
  if (isPaid !== null && isPaid !== undefined) url += `&isPaid=${isPaid}`;
  return url;
};
export const BILLING_INVOICE = (id) => `/invoicing-system/billing-invoices/${id}`;
export const CREATE_BILLING_INVOICE = "/invoicing-system/billing-invoices";
export const UPDATE_BILLING_INVOICE = (id) => `/invoicing-system/billing-invoices/${id}`;
export const UPDATE_BILLING_INVOICE_REFERENCE = (id) => `/invoicing-system/billing-invoices/${id}/reference`;
export const SEND_BILLING_INVOICE = (id) => `/invoicing-system/billing-invoices/${id}/send`;
export const CANCEL_BILLING_INVOICE = (id) => `/invoicing-system/billing-invoices/${id}/cancel`;
export const TOGGLE_BILLING_INVOICE_PAID = (id) => `/invoicing-system/billing-invoices/${id}/toggle-paid`;
export const GENERATE_ALL_BILLING_INVOICES = "/invoicing-system/billing-invoices/generate-all";

// Billing Invoice Items
export const BILLING_INVOICE_ITEMS = (id) => `/invoicing-system/billing-invoices/${id}/items`;
export const CREATE_BILLING_INVOICE_ITEM = (id) => `/invoicing-system/billing-invoices/${id}/items`;
export const UPDATE_BILLING_INVOICE_ITEM = (id, itemId) => `/invoicing-system/billing-invoices/${id}/items/${itemId}`;
export const DELETE_BILLING_INVOICE_ITEM = (id, itemId) => `/invoicing-system/billing-invoices/${id}/items/${itemId}`;

// Billing Invoice Payments
export const BILLING_INVOICE_PAYMENTS = (id) => `/invoicing-system/billing-invoices/${id}/payments`;
export const CREATE_BILLING_INVOICE_PAYMENT = (id) => `/invoicing-system/billing-invoices/${id}/payments`;
export const UPDATE_BILLING_INVOICE_PAYMENT = (id, paymentId) => `/invoicing-system/billing-invoices/${id}/payments/${paymentId}`;
export const DELETE_BILLING_INVOICE_PAYMENT = (id, paymentId) => `/invoicing-system/billing-invoices/${id}/payments/${paymentId}`;

// Billing System - Additional endpoints
export const FETCH_INVOICE_SCHEMAS = "/invoicing-system/invoice-schemas";
export const FETCH_INVOICE_SCHEMA_IDS = "/invoicing-system/invoice-schemas/ids";
export const FETCH_INVOICE_SCHEMA = (id) => `/invoicing-system/invoice-schemas/${id}`;
export const CREATE_INVOICE_SCHEMA = "/invoicing-system/invoice-schemas";
export const UPDATE_INVOICE_SCHEMA = (id) => `/invoicing-system/invoice-schemas/${id}`;
export const DELETE_INVOICE_SCHEMA = (id) => `/invoicing-system/invoice-schemas/${id}`;
export const FETCH_BILLING_COMPANIES = "/invoicing-system/billing-companies";
export const CREATE_BILLING_COMPANY = "/invoicing-system/billing-companies";
export const UPDATE_BILLING_COMPANY = (id) => `/invoicing-system/billing-companies/${id}`;
export const DELETE_BILLING_COMPANY = (id) => `/invoicing-system/billing-companies/${id}`;

// Invoice Prefixes
export const FETCH_INVOICE_PREFIXES = (page, perPage, isActive, search, sortBy, order) => {
  let url = `/invoicing-system/invoice-prefixes?page=${page}&perPage=${perPage}`;
  if (isActive !== null && isActive !== undefined) url += `&isActive=${isActive}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (sortBy) url += `&sortBy=${encodeURIComponent(sortBy)}`;
  if (order) url += `&order=${encodeURIComponent(order)}`;
  return url;
};
export const FETCH_INVOICE_PREFIX = (id) => `/invoicing-system/invoice-prefixes/${id}`;
export const CREATE_INVOICE_PREFIX = "/invoicing-system/invoice-prefixes";
export const UPDATE_INVOICE_PREFIX = (id) => `/invoicing-system/invoice-prefixes/${id}`;
export const DELETE_INVOICE_PREFIX = (id) => `/invoicing-system/invoice-prefixes/${id}`;

// Object Codes
export const FETCH_OBJECT_CODES = (page, perPage, isActive, search, sortBy, order) => {
  let url = `/invoicing-system/object-codes?page=${page}&perPage=${perPage}`;
  if (isActive !== null && isActive !== undefined) url += `&isActive=${isActive}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (sortBy) url += `&sortBy=${encodeURIComponent(sortBy)}`;
  if (order) url += `&order=${encodeURIComponent(order)}`;
  return url;
};
export const FETCH_OBJECT_CODE = (id) => `/invoicing-system/object-codes/${id}`;
export const CREATE_OBJECT_CODE = "/invoicing-system/object-codes";
export const UPDATE_OBJECT_CODE = (id) => `/invoicing-system/object-codes/${id}`;
export const DELETE_OBJECT_CODE = (id) => `/invoicing-system/object-codes/${id}`;
export const GENERATE_INVOICE_FROM_SCHEMA = (schemaId) => `/invoicing-system/invoice-schemas/${schemaId}/generate-invoice`;
export const BULK_CREATE_BILLING_INVOICES = "/invoicing-system/billing-invoices/bulk-create";
export const EXPORT_BILLING_INVOICES = (billingPeriodStart, billingPeriodEnd, companyId, status, isPaid, format) => {
  let url = `/invoicing-system/billing-invoices/export`;
  const params = [];
  if (billingPeriodStart) params.push(`billingPeriodStart=${encodeURIComponent(billingPeriodStart)}`);
  if (billingPeriodEnd) params.push(`billingPeriodEnd=${encodeURIComponent(billingPeriodEnd)}`);
  if (companyId) params.push(`companyId=${companyId}`);
  if (status) {
    if (Array.isArray(status)) {
      status.forEach(s => {
        if (s) params.push(`status=${encodeURIComponent(s)}`);
      });
    } else if (typeof status === 'string' && status.includes(',')) {
      status.split(',').forEach(s => {
        const trimmed = s.trim();
        if (trimmed) params.push(`status=${encodeURIComponent(trimmed)}`);
      });
    } else {
      params.push(`status=${encodeURIComponent(status)}`);
    }
  }
  if (isPaid !== null && isPaid !== undefined) params.push(`isPaid=${isPaid}`);
  if (format) params.push(`format=${encodeURIComponent(format)}`);
  if (params.length > 0) url += `?${params.join('&')}`;
  return url;
};

// Notification Recipients
export const NOTIFICATION_RECIPIENTS = "/notification-recipient";
export const NOTIFICATION_RECIPIENT = (id) => `/notification-recipient/${id}`;
export const NOTIFICATION_RECIPIENT_TOGGLE = (id) => `/notification-recipient/${id}/toggle`;

// Notification Subscriptions (per-user, per-business-unit)
export const NOTIFICATION_SUBSCRIPTIONS = "/notification-subscription";
export const NOTIFICATION_SUBSCRIPTION = (id) => `/notification-subscription/${id}`;
export const NOTIFICATION_SUBSCRIPTION_TOGGLE = (id) => `/notification-subscription/${id}/toggle`;

// Users list for dropdown
export const FETCH_USERS_LIST = "/users/list";

// Business Units list for dropdown
export const FETCH_BUSINESS_UNITS_LIST = "/companies/business-units/list";
